import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import Datepicker from 'vuejs-datepicker'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'
import StateRepository from '@/shared/http/repositories/geo/state'
import CityRepository from '@/shared/http/repositories/geo/city'
import EmployeeBoardRepository from '@/shared/http/repositories/business/employeeboard.js'
import EmployeeBoardHistoryRepository from '@/shared/http/repositories/business/employeeboardhistory.js'
import SectionRHRepository from '@/shared/http/repositories/business/sectionrh.js'
import AddBoardModel from '@/shared/models/business/employeeboardmodel.js'
import AddBoardForm from './addboard-form.js'
import BoardMixin from '../../../mixins/BoardMixin.js'

const GEO_BRAZIL = '2375E209-7451-4A7A-A9BE-66BD2C392BE1'

export default {
  name: 'addboard',
  mixins: [ ActionsForm, BoardMixin ],
  data () {
    return {
      data: AddBoardModel,
      form: AddBoardForm,
      en: en,
      es: es,
      ptBR: ptBR,
      objSelected: null
    }
  },
  components: {
    Datepicker,
    AutocompleteZ
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.observacao.maxlength)
    }
  },
  created () {
    this.onLoadAllSections()
    this.onLoadAllState()
  },
  methods: {
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.objSelected = null
      this.$refs.obraRHTypeahead.clear()
      this.$refs.responsavelTypeahead.clear()
      this.$nextTick(() => this.$refs.pedidoComp.$el.focus())
    },
    onBack () {
      this.$emit('Back', this.objSelected)
    },
    onLoadAllSections () {
      loading.push()
      SectionRHRepository.GetAll(this.CompanySelected)
        .then((response) => {
          this.form.secaoRHID.options = this.onResultDropdown(response, null, (f) => f.codigo + ' - ' + f.nome)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onClearSection () {
      this.form.secaoRH.value = ''
    },
    onChangeCodeSection (value) {
      var options = this.form.secaoRHID.options
      this.form.secaoRHID.value = ''
      for (var i in options) {
        var names = options[i].text.split('-')
        if (names[0].trim().toUpperCase() === value.toUpperCase()) {
          this.form.secaoRHID.value = options[i].value
        }
      }
    },
    onLoadAllState () {
      loading.push()
      StateRepository.GetAllByCountryID(GEO_BRAZIL)
        .then((response) => {
          this.form.estadoID.options = this.onResultDropdown(response, null, f => f.sigla + ' - ' + f.nome)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onChangeState () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllCity(self.form.estadoID.value)
      }, 500)
    },
    onLoadAllCity (id) {
      this.form.cidadeID.options = []
      if (id) {
        loading.push()
        CityRepository.GetAllByStateID(id)
          .then((response) => {
            this.form.cidadeID.options = this.onResultDropdown(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onCreate () {
      loading.push()
      this.data.empresaID = this.CompanySelected
      this.data.situacao = 0
      EmployeeBoardRepository.Create(this.data)
        .then((response) => {
          if (response.data.code >= 0) {
            this.objSelected = response.data.data
            this.onCreateHistory(this.objSelected, 'CRIOU O QUADRO')
            loading.close()
            toast.success(this.$lang.Common.Alerts.Success)
            this.onBack()
          } else {
            loading.close()
            toast.error(this.$lang.Common.ActionNotTaken)
          }
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.empresaID = this.CompanySelected
      this.data.pedido = this.data.pedido && this.data.pedido.toString()
      this.data.status = parseInt(this.data.status)
      EmployeeBoardRepository.Update(this.data)
        .then((response) => {
          if (response.data.code >= 0) {
            this.objSelected = response.data.data
            this.onCreateHistory(this.objSelected, 'EDITOU O QUADRO')
            loading.close()
            toast.success(this.$lang.Common.Alerts.Success)
            this.onBack()
          } else {
            loading.close()
            toast.error(this.$lang.Common.ActionNotTaken)
          }
        })
        .catch(this.onException)
    },
    onEdit (obj) {
      this.data.id = obj.id
      Tools.SetValueInForm(this.form, this.data, obj)
      this.objSelected = obj
      if (obj.obraRH && obj.obraRH.codigo > 0) {
        this.$refs.obraRHTypeahead.setValue(obj.obraRH)
      }
      if (obj.responsavel && obj.responsavel.codigo > 0) {
        this.$refs.responsavelTypeahead.setValue(obj.responsavel)
      }
      if (obj.clienteRH && obj.clienteRH.codigo > 0) {
        this.$refs.clienteRHTypeahead.setValue(obj.clienteRH)
      }
      if (obj.cidade.estado) {
        this.form.estadoID.value = obj.cidade.estado.id
        this.onLoadAllCity(obj.cidade.estado.id)
      }

      var self = this
      setTimeout(function (e) {
        self.form.cidadeID.value = obj.cidadeID
      }, 500)
    },
    onCreateHistory (obj, action) {
      let result = false
      const history = {
        quadroFuncionarioID: obj.id,
        autorID: obj.contaIDAcao,
        dataCriacao: obj.dataAcao,
        ip: this.ip,
        latitude: this.latitude ? this.latitude.toString() : '',
        longitude: this.longitude ? this.longitude.toString() : '',
        acao: action,
        observacaoMotivo: '',
        status: 1
      }
      EmployeeBoardHistoryRepository.Create(history)
        .then((response) => {
          if (response.data.code >= 0) {
            result = true
          }
        })
        .catch(this.onException)
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/employeeboard/board/components/addboard/addboard.js